import { Suspense, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAuth } from '../../hooks/useAuth'
import { lazyWithReload } from '../../utils/lazyWithReload'
import { shouldUseNativeWelcome } from '../../config/nativeWelcome'
import { getPostAuthDestination } from '../../lib/postAuthRouting'
import { hasActiveNativeAuthIntent } from '../../lib/nativeAuthIntent'

const NativeWelcomePage = lazyWithReload(
  () => import('../../pages/NativeWelcomePage'),
  'NativeWelcomePage'
)

type Props = {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export default function MobileRootRedirect({ children, fallback = null }: Props) {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const useNativeWelcome = shouldUseNativeWelcome()
  const authHandlerOwnsTransition = Boolean(user && hasActiveNativeAuthIntent())
  const destination =
    useNativeWelcome && !loading && user && !authHandlerOwnsTransition
      ? getPostAuthDestination()
      : null

  useEffect(() => {
    if (destination) {
      void navigate(destination, { replace: true })
    }
  }, [destination, navigate])

  if (!useNativeWelcome) {
    return <>{children}</>
  }

  if (loading || user) {
    return <>{fallback}</>
  }

  return (
    <Suspense fallback={fallback}>
      <NativeWelcomePage />
    </Suspense>
  )
}
